import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Steps } from 'hljd'
import style from './style.module.less'

const Step = Steps.Step

@inject('parentStore')
@observer
export default class extends Component {
  render() {
    const {
      parentStore: { step }
    } = this.props
    return (
      // <div className={style.stepsBar}></div>
      <div className={style.stepsBar}>
        <Steps current={+step - 1}>
          <Step title="上传图片" description="" />
          <Step title="生成转介绍海报" description="" />
        </Steps>
      </div>
    )
  }
}
